
//Cancel out the annoying formats for the phone-number
//https://stackoverflow.com/questions/3736807/how-do-i-remove-the-blue-styling-of-telephone-numbers-on-iphone-ios
export const meta = (meta) => {
  meta.addMetaItem([
    { name:'format-detection', content: 'telephone=no' },
  ])
  meta.addHTMLAttribute([
    { name:'style', value:'overflow-x: hidden'}
  ])
}
  
export const extraJS = null
  
export const externalCSS = [
  "https://fonts.googleapis.com/css2?family=Manrope:wght@500;700;800&amp;family=IBM+Plex+Mono:wght@500;600&amp;display=swap"
]
